import { CustomTable, EAsociationType, EInputTypes, ETypeOfNotification, FilterDTO, InputTextCustom, MATCH_MODES, Modal, ResponseDTO, createFiltersForMobile, muifContext, setNotification, stringFilterTemplate } from 'medere-ui-framework'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Button } from 'primereact/button'
import './Contacts.scss'
import { Column } from 'primereact/column'
import { useIntl } from 'react-intl'
import { MedereEntityContactDTO, defaultMedereEntityContactDTO } from '../../interface/MedereEntityContactDTO'
import ContactForm from './ContactForm'
import { AxiosResponse } from 'axios'
import ContactCard from './ContactCard'
import { useDispatch } from 'react-redux'
import { useContactsService } from '../../servicesHooks/Contacts/useContactsService'

interface IProps {
  entityid: number,
  getContactsTypes: any
}

export default function EntityContacts({ entityid, getContactsTypes }: Readonly<IProps>) {

  const intl = useIntl();
  const dispatch = useDispatch();
  const { deleteContact, getEntityContacts, getMedereEntityContact } = useContactsService();
  const { mobile }: any = useContext(muifContext);
  const table: any = useRef(null);

  const [filterDTO, setFilterDTO] = useState<FilterDTO>({ filters: [], associationType: EAsociationType.OR, filterLists: null });
  const [filterValue, setFilterValue] = useState<string>('');
  const [modalData, setModalData]: any = useState({ visiblity: false, contact: defaultMedereEntityContactDTO });

  useEffect(() => {
    !mobile && handleFilterChange("");
  }, [mobile])

  const handleFilterChange = (newValue: string) => {
    let _filterDTO: FilterDTO = createFiltersForMobile(newValue,
      [
        { fieldName: "contactname", filterType: MATCH_MODES.CONTAINS },
        { fieldName: "contactlastname", filterType: MATCH_MODES.CONTAINS },
        { fieldName: "contactphone", filterType: MATCH_MODES.CONTAINS },
        { fieldName: "contactemail", filterType: MATCH_MODES.CONTAINS },
        { fieldName: "addressdesc", filterType: MATCH_MODES.CONTAINS },
        //{ fieldName: "contact_types_string", filterType: MATCH_MODES.CONTAINS },
        { fieldName: "contact_type", filterType: MATCH_MODES.CONTAINS },
      ]);
    // Actualizar el estado utilizando el setter original
    setFilterValue(newValue);
    setFilterDTO(_filterDTO);
  }


  function closeModal(updateGrid: boolean) {
    setModalData({ visiblity: false, contact: defaultMedereEntityContactDTO });
    updateGrid && table.current?.refreshTable();
  }

  function deleteHandler(e: MedereEntityContactDTO) {
    deleteContact(e.medereentity_contact)
      .then((res: AxiosResponse) => {
        let data: ResponseDTO = res.data;
        if (data.success) {
          dispatch(setNotification({ title: 'Contacto eliminado', desc: '', icon: 'pi-check-circle', typeOfNotification: ETypeOfNotification.INFO }))
          table.current.removeRowByFieldName("medereentity_contact", e.medereentity_contact)
        } else dispatch(setNotification({
          title: intl.formatMessage({ id: "ChangesCouldNotBeSaved" }),
          desc: '',
          icon: 'pi-times',
          typeOfNotification: ETypeOfNotification.WARNING
        }))
      })
      .catch(() => dispatch(setNotification({
        title: intl.formatMessage({ id: "ChangesCouldNotBeSaved" }),
        desc: '',
        icon: 'pi-times',
        typeOfNotification: ETypeOfNotification.WARNING
      })));
  }

  function editHandler(e: MedereEntityContactDTO) {
    getMedereEntityContact(e.medereentity, e.medereentity_contact)
      .then((res: any) => {
        
        let contactTypes: any[] = res.map((item: any) => ({
          id: item.medereentity_contacttype,
          description: item.contact_type
        }));
  
        let contactTypesString: string = contactTypes.map((item: any) => item.description).join(", ");
  
        let contact: MedereEntityContactDTO = {
          medereentity_contact: e.medereentity_contact,
          medereentity_contacttype: e.medereentity_contacttype,
          contact_type: e.contact_type,
          medereentity: e.medereentity,
          contactname: e.contactname,
          contactlastname: e.contactlastname,
          contactemail: e.contactemail,
          contactphone: e.contactphone,
          address: e.address,
          addressdesc: e.addressdesc,
          contact_types_string: contactTypesString,
          addresstypes: e.addresstypes,
          hasChanges: e.hasChanges,
          contact_types: contactTypes
        };

        setModalData({ visiblity: true, contact: contact })
      })
      .catch(() => dispatch(setNotification({
        title: intl.formatMessage({ id: "ChangesCouldNotBeSaved" }),
        desc: '',
        icon: 'pi-times',
        typeOfNotification: ETypeOfNotification.WARNING
      })));
  }

  return (
    <React.Fragment>
      <div className='ml-3.5 flex flex-column'style={{height: '500px'}}>
        {mobile &&
          <InputTextCustom
            value={filterValue}
            floatLabel
            label={intl.formatMessage({ id: "Search" })} inputType={EInputTypes.TEXT}
            onChange={(e: any) => handleFilterChange(e.target.value)} />}
        <Button
          className='align-self-end  buttonSecondary p-button-rounded'
          icon="pi pi-user-plus"
          onClick={() => setModalData({ ...modalData, visiblity: true })} />
        <CustomTable
          idTable="contactsTable"
          ref={table}
          filterRow
          getItems={getEntityContacts}
          params={{ cardFilterDTO: filterDTO || null, medereentity: entityid }}
          buttonController
          dropdownButton={{ deleted: deleteHandler, edit: editHandler }}
          CardTemplate={ContactCard}
          rowButtonClassName='buttonSecondary2TableButtons'
          cardKeyName="medereentity_contact"
          cardEditBtn={{ className: 'buttonSecondary2', icon: 'pi-file-edit' }}
          cardDeleteBtn={{ className: 'buttonSecondary2', icon: 'pi-trash' }}>
          {/*<Column field="contact_types_string" filter header={intl.formatMessage({ id: "Type" })}*/ /*body={bodyDescriptionTemplate} filterElement={stringFilterTemplate}*//* />*/}
          <Column field="contact_type" header={intl.formatMessage({ id: "Type" })}/>

          <Column field="contactname" filter style={{ maxWidth: 200 }} header={intl.formatMessage({ id: "Name" })} filterElement={stringFilterTemplate} />
          <Column field="contactlastname" filter style={{ maxWidth: 200 }} header={intl.formatMessage({ id: "Lastname" })} filterElement={stringFilterTemplate} />
          <Column field="contactphone" filter style={{ maxWidth: 200 }} header={"Telefono o Celular"} filterElement={stringFilterTemplate} />
          <Column field="contactemail" filter header="Email" filterElement={stringFilterTemplate} />
        </CustomTable>
        <Modal
          visible={modalData.visiblity}
          setVisible={() => { setModalData({ ...modalData, visiblity: true }) }}
          header={<h5 className='info-dark'>{intl.formatMessage({ id: "Contact" })}</h5>}
          className="contact-modal"
          onHideCustom={() => { setModalData({ visiblity: false, contact: defaultMedereEntityContactDTO }) }}>
          <ContactForm
            getContactsTypes={getContactsTypes}
            closeModal={closeModal}
            medereentity={entityid}
            contactParam={modalData.contact} />
        </Modal>
      </div>
    </React.Fragment>)
}
